<template>
  <div>
    <template v-if="!breadcrumb">
      <div class="col-sm-12 col-xs-12 col-md-12 pl-24">
        <div class="header-team first-lette-cap">
          {{header}}
          <!-- <i
            class="el-icon-close icon-close"
            @click="$emit('closepopup', 'closeBasePopup')"
          ></i> -->
          <img src="/static/images/icons/close_x.svg"  class="el-icon-close icon-close"
            @click="$emit('closepopup', 'closeBasePopup')">
        </div>
      </div>
      <div v-if="displaySubheader">
        <div class="subHeader col-md-12 first-lette-cap hide_xs" v-if="subheader !== 'services'" :class="{'mb-0': subheader === 'dashboard' }">{{subheader}}</div>
        <div class="subHeader col-md-12 hide_xs" v-if="subheader === 'services'">My Services</div>
        <div class="col-me-4 col-sm-4 col-xs-7">
          <multiselect
            :showLabels="false"
            :close-on-select="true"
            :allow-empty="false"
            class="multiselect-single-dropdown"
            :searchable="false"
            open-direction="bottom"
            :options="subPagesList"
            :custom-label="value => value.toString().charAt(0).toUpperCase() + value.toString().slice(1)"
            v-model="subPage"
            @input="changePage"
            placeholder="Select Page"
          >
          </multiselect>
        </div>
      </div>
    </template>
    <template v-else>
      <div v-if="breadcrumb === 'New Member' || breadcrumb === 'Member'">
        <div class="col-sm-12 col-xs-12 col-md-12">
          <div class="header-team first-lette-cap">
            <span class="hide_xs" v-if="subheader === 'team'">{{ $t('teamManagement')}}</span>
            <span class="hide_xs" v-else>{{subheader}}</span>
            <span class="first-lette-cap" v-if="breadcrumb === 'New Member'">
              <img
                src="/static/images/icons/team_header_right_chevron.svg"
                class="hide_xs right_chevron"
                width="24px"
                height="24px"
              />
              <span>{{ $t('newMember')}}</span>
            </span>
            <span class="first-lette-cap" v-else>
              <img
                src="/static/images/icons/team_header_right_chevron.svg"
                class="hide_xs right_chevron"
                width="24px"
                height="24px"
              />
              {{$t('member')}}
            </span>
            <i class="el-icon-close icon-close" @click="$emit('emit-close-event')"></i>
          </div>
        </div>
      </div>
      <div v-if="breadcrumb === 'Update Service'">
        <div class="col-sm-12 col-xs-12 col-md-12 pl-24">
          <div class="header-team first-lette-cap">
            <span class="hide_xs" v-if="subheader === 'team'">{{ $t('updateService')}}</span>
            <span class="hide_xs" v-else-if="subheader === 'services'">{{ $t('services')}}</span>
            <span class="hide_xs" v-else>{{subheader}}</span>
            <span class="first-lette-cap" v-if="breadcrumb === 'Update Service'">
              <img
                src="/static/images/icons/team_header_right_chevron.svg"
                class="hide_xs right_chevron"
                width="24px"
                height="24px"
              />
              <span>{{ $t('updateAccount')}}</span>
            </span>
            <span class="first-lette-cap" v-else>
              <img
                src="/static/images/icons/team_header_right_chevron.svg"
                class="hide_xs right_chevron"
                width="24px"
                height="24px"
              />
              {{breadcrumb}}
            </span>
            <i class="el-icon-close icon-close" @click="$emit('closepopup', 'closeBasePopup')"></i>
          </div>
        </div>
      </div>
      <div v-if="breadcrumb === 'Billing Information'">
        <div class="col-sm-12 col-xs-12 col-md-12 pl-24">
          <div class="header-team first-lette-cap">
            <span class="hide_xs" v-if="subheader === 'team'">{{ $t('billingInformation')}}</span>
              <span class="hide_xs" v-else-if="subheader === 'billing'">{{ $t('billing')}}</span>
            <span class="hide_xs" v-else>{{subheader}}</span>
            <span class="first-lette-cap" v-if="breadcrumb === 'Billing Information'">
              <img
                src="/static/images/icons/team_header_right_chevron.svg"
                class="hide_xs right_chevron"
                width="24px"
                height="24px"
              />
              <span>{{ $t('changeBillingInfo')}}</span>
            </span>
            <span class="first-lette-cap" v-else>
              <img
                src="/static/images/icons/team_header_right_chevron.svg"
                class="hide_xs right_chevron"
                width="24px"
                height="24px"
              />
              {{breadcrumb}}
            </span>
            <img src="/static/images/icons/close_x.svg"  class="el-icon-close icon-close"
            @click="$emit('closepopup', 'closeBasePopup')">
            <!-- <i class="el-icon-close icon-close" @click="$emit('closepopup', 'closeBasePopup')"></i> -->
          </div>
        </div>
      </div>
         <div v-if="breadcrumb === 'Add Address'||breadcrumb === 'Edit Address'">
        <div class="col-sm-12 col-xs-12 col-md-12 pl-24">
          <div class="header-team first-lette-cap">
            <span class="hide_xs" v-if="subheader === 'companyProfile'">{{ $t('companyProfile')}}</span>
            <span class="first-lette-cap">
              <img
                src="/static/images/icons/team_header_right_chevron.svg"
                class="hide_xs right_chevron cursor-pointer"
                width="24px"
                height="24px"
              />
              {{breadcrumb==='Add Address'?$t('addAddress'):$t('editAddress')}}
            </span>
            <img src="/static/images/icons/close_x.svg"  class="el-icon-close icon-close"
            @click="$emit('closepopup', 'closeBasePopup')">
            <!-- <i class="el-icon-close icon-close" @click="$emit('closepopup', 'closeBasePopup')"></i> -->
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>

export default {
  props: ['subheader', 'header', 'breadcrumb', 'displaySubheader', 'roleId'],
  data() {
    return {
      subPagesList: ['notifications', 'dashboard', 'preferences'],
      subPage: '',
    };
  },
  filters: {
    capitalize(value) {
      if (!value) return '';
      return value.toString().charAt(0).toUpperCase() + value.toString().slice(1);
    },
  },
  async created() {
    if (this.roleId === 1 || this.roleId === 5 || this.roleId === 9) {
      this.subPagesList.push('team');
      this.subPagesList.push('services');
    }
    const accountTypeId = JSON.parse(localStorage.getItem('userData')).account_type_id;
    const isREP = accountTypeId === 2 || accountTypeId === 4;
    if (!isREP && (this.roleId === 1 || this.roleId === 5)) {
      this.subPagesList.push('billing');
    }
  },
  methods: {
    changePage() {
      this.$emit('changePage', this.subPage);
    },
  },
  watch: {
    subheader() {
      this.subPage = this.subheader;
    },
    isDashboardCustomizable() {
      if (this.isDashboardCustomizable && (this.roleId !== 4 && this.roleId !== 11 && this.roleId !== 10 && this.roleId !== 12)) {
        this.subPagesList.push('dashboard');
      }
    },
  },
};
</script>
<style scoped>
.right_chevron{
  margin-left: 24px;
  margin-right: 24px;
}
.mr-24{
  margin-right: 24px;
}
.ml-24{
  margin-left: 24px;
}

.mr-14 {
  margin-right: 14px;
}

.header-team {
  padding: 24px 0px 0px 0px;
  font-size: 20px;
  line-height: 27px;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  color: #1A1A1A;
}
.icon-close {
  color: #333333 !important;
  float: right;
  cursor: pointer;
  padding-right: 9px;
}
.subHeader {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  color: #0b3c61;
  margin-top: 10px;
  margin-bottom: 15px;
}
.mb-0 {
  margin-bottom: 0px;
}
.first-lette-cap::first-letter {
  text-transform: capitalize;
}
.multiselect-single-dropdown {
  display: none;
  margin-top: 10px;
  margin-bottom: 15px;
}
.multiselect-single-dropdown >>> .multiselect__content-wrapper {
  max-height: 180px !important;
}
@media screen and (max-width: 767px) {
  .hide_xs {
    display: none;
  }
}
@media screen and (max-width: 1300px) {
  .subHeader {
    display: none;
  }
  .multiselect-single-dropdown {
    display: block !important;
  }
}
@media screen and (max-width: 374px) {
  .header-team {
    font-size: 25px;
    line-height: 25px;
  }
}
</style>
